module.exports = __webpack_public_path__ + "static/img/lixinniannian.aa5fc66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lixinniannian.jpg
// module id = ka6+
// module chunks = 0